<template>
  <div :class="classList" class="service-selector-option">
    <button class="select-button" @click="handleClickSelectButton">
      <img :src="iconUrl" class="icon" />
      <div class="meta">
        <h4 class="name">{{ name }}</h4>
        <p v-if="showDesc" class="desc">{{ desc }}</p>
        <div class="provider">
          <img :src="provider.logoUrl" class="logo" />
          <p class="name">{{ provider.name }}</p>
        </div>
      </div>
    </button>
    <div v-if="canRemove" class="action">
      <sc-button :icon="true" variant="clean" @click="handleClickRemoveButton">
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ScButton,
  },
  props: {
    iconUrl: { type: String, default: null },
    name: { type: String, default: null },
    shortDescription: { type: String, default: null },
    description: { type: String, default: null },
    provider: { type: Object, default: () => ({}) },
    canSelect: { type: Boolean, default: false },
    canRemove: { type: Boolean, default: false },
    id: { type: [Number, String], default: null },
  },
  computed: {
    desc() {
      if (!this.description) {
        return this.shortDescription
      }

      if (!this.shortDescription) {
        return this.description
      }

      return `${this.shortDescription} — ${this.description}`
    },
    showDesc() {
      return !!(this.shortDescription || this.description)
    },
    classList() {
      return { selectable: this.canSelect }
    },
  },
  methods: {
    handleClickSelectButton() {
      if (this.canSelect) {
        this.$emit("select")
      } else if (this.$router) {
        const routeByServiceId = {
          name: "ServiceDetailPage",
          params: { id: this.id },
        }
        const routeDataByServiceId = this.$router.resolve(routeByServiceId)
        window.open(routeDataByServiceId.href, "_blank")
      }
    },
    handleClickRemoveButton() {
      this.$emit("remove")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 48px;
$padding: 10px ($space / 2);

.service-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;

  padding: $padding;

  font-family: "Sukhumvit Tadmai";

  >.select-button {
    cursor: default;
    user-select: text;
  }

  &.selectable {
    padding: 0;

    >.select-button {
      padding: $padding;
      cursor: pointer;
    }

    &:hover {
      background: #efefef;
    }
  }

  >.action {
    align-self: center;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  >.icon {
    margin-top: 5px;

    flex: 0 0 $logoSize;
  }

  >.meta {
    padding-left: 20px;
    display: block;

    flex-grow: 1;

    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.icon {
  display: block;

  border-radius: 8px;
  width: $logoSize;
  height: $logoSize;
}

.meta {
  min-width: 0;

  >.desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 0.9rem;
}

.meta p {
  font-size: 0.8rem;
  color: #777;
}

.meta .name,
.meta p {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  >.provider {
    padding-left: 15px;
  }
}

.provider {
  margin-top: 3px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  >.logo {
    margin-right: 8px;

    border-radius: $border-radius;
    width: 20px;
    height: 20px;
  }

  >.name {
    font-size: 0.8rem;
    color: black;
  }
}
</style>
